import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { media } from "@atlaskit/primitives";
import { token } from "@atlaskit/tokens";

import { ProviderLogo } from "@/components/signup/account-creation/components/social/components/provider-logo";
import { useAccountCreationContext } from "@/components/signup/account-creation/hooks/account-creation-context";
import { Button } from "@/libraries/design/components";
import { wacToken } from "@/libraries/design/foundations";

export const SocialButton = () => {
    const intl = useIntl();
    const { onClickSocialButton } = useAccountCreationContext();

    return (
        <Button
            css={buttonCss}
            role="link"
            aria-label={intl.formatMessage(
                {
                    id: "social.label.signup",
                    defaultMessage: "sign up with {provider}"
                },
                {
                    provider: "Google"
                }
            )}
            onClick={() => onClickSocialButton("google")}
            dataEventProps={{
                "data-product-key": "uniform",
                "data-event": "clicked",
                "data-event-component": "button",
                "data-event-container": "signup",
                "data-label": "sign up with Google",
                "data-label-english": "sign up with Google"
            }}
        >
            <ProviderLogo logo="google" />
            <span>Google</span>
        </Button>
    );
};

const buttonCss = css({
    alignItems: "center",
    backgroundColor: wacToken("color.neutral.light0"),
    // eslint-disable-next-line local/ensure-wac-token-usage
    border: "1px solid #8C8F97 !important",
    boxSizing: "border-box",
    color: `${token("color.text.subtle")} !important`,
    display: "flex",
    fontFamily: "inherit",
    fontSize: "18px",
    fontWeight: 400,
    gap: "0.5rem",
    height: "48px",
    justifyContent: "center",
    minWidth: "auto",
    whiteSpace: "nowrap",
    width: "fit-content",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ["svg"]: {
        minHeight: "18px",
        minWidth: "18px"
    },
    ["&:focus, &:hover"]: {
        backgroundColor: wacToken("color.neutral.light200")
    },
    [media.below.sm]: {
        width: "100%",
        maxWidth: "100%"
    }
});
